import { useState } from 'react';
import { createUUID } from '@mews/std';

/**
 * @returns a referentially stable UUID to be used in react components
 */
export const useUUID = () => {
    const [uuid] = useState(() => createUUID());
    return uuid;
};
